export default __webpack_public_path__ + "static/media/invest.bad0dfc4.svg";